import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useT } from "@transifex/react";
import ContentWithHeader from "../../../wrapper/ContentWithHeader/ContentWithHeader";
import { redirectScreenDelayMs } from "../../../constants/RedirectConstants";

const CreateRtHome: React.FC = () => {
    const history = useHistory();
    const t = useT();
    const t_redirecting = t("You are being redirected…", { _tags: "TeacherArea" });

    useEffect(() => {
        const timer = setTimeout(() => history.push("/assistent"), redirectScreenDelayMs);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ContentWithHeader isAreaHeader>
            <div className="flex flex-1 items-center justify-center">
                <p className="text-xl">{t_redirecting}</p>
            </div>
        </ContentWithHeader>
    );
};

export default CreateRtHome;
